<template>
  <div class="m-exhibition-venues__columns">
    <div class="m-exhibition-venues__column-venues">
      <div class="m-exhibition-venues__venue-selector">
        <!-- hidden venue selector heading for accessibility -->
        <h2 class="a-venue-selector__venues">
          {{ $t("o-exhibition-venues.venues") }}
        </h2>
        <div class="a-venue-selector__venue_container">
          <!-- list of selectable venues -->
          <h3 id="venue_selector_aria" class="visually-hidden">
            {{ $t("o-exhibition-venues.venue_selector_heading_aria") }}
          </h3>
          <ul
            aria-labelledby="venue_selector_aria"
            class="a-venue-selector__list"
          >
            <li
              v-for="venue in exhibition.venues"
              ref="venueSnippetContainer"
              :key="venue.id"
              class="a-venue-selector__venue"
            >
              <div
                class="o-exhibition-venues-snippet"
                data-testid="venueSnippet"
              >
                <div class="o-exhibition-venues-snippet__heading">
                  <GuiLink v-if="venue.route != undefined" :to="venue.route">
                    {{ venue.institutionName }}
                  </GuiLink>
                  <div v-else>
                    {{ venue.institutionName }}
                  </div>
                </div>
                <div
                  v-if="venue.location"
                  class="o-exhibition-venues-snippet__subhead"
                >
                  {{ venue.location }}
                </div>
                <div
                  v-if="venue.dates.content"
                  class="o-exhibition-venues-snippet__dates"
                >
                  {{ venue.dates.content }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="m-exhibition-venues__column-objects">
      <div class="m-venue-objects">
        <!-- exhibition venue objects -->
        <RelatedSearchResults
          v-if="exhibition?.items?.data"
          ref="relatedObjects"
          class="m-exhibition-venues__related_search_results"
          :search-params="searchParams"
          :aria-heading="ariaHeading"
          :heading="heading"
          :max-items-per-row="4"
          :items="exhibition?.items?.data"
          :total="exhibition?.items?.total"
          :use-route="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RelatedSearchResults from "@/components/molecules/relatedSearchResults/index.vue";
import { useLocalization, GuiLink } from "@thegetty-private/getty-ui";
import { getIndexedId } from "@thegetty-private/rad-app-utils";

export default {
  name: "ExhibitionVenues",
  components: {
    RelatedSearchResults,
    GuiLink
  },

  props: {
    /**
     * The Exhibition JSON-LD Object
     */
    exhibition: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * total # of search results
       */
      totalSearchResults: undefined,
      /**
       * The Aria label for the search results
       */
      ariaHeading: this.translatePart("exhibition_page.results_aria_heading"),
      /**
       * Temporary harded coded count for loan objects (placeholder)
       */
      count: 7,
      /**
       * The heading for the section
       */
      heading: this.translatePart("exhibition_page.exhibited_works"),
      /**
       * Translated text for the Getty Objects heading
       *
       * @returns {string}
       */
      exhibitionObjectsHeading: this.translatePart(
        "exhibition_page.getty_objects"
      ),
      /**
       * Object used in the RelatedSearchResults to get Exhibition venue/Activity HMOs
       */ searchParams: undefined,
      /**
       * the # of results to show
       */
      size: 24
    };
  },
  computed: {
    /**
     * The indexedId of the parent Exhibition
     *
     * @returns {String}
     */
    exhibitionIndexedId() {
      return getIndexedId(this.exhibition.id);
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
